import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterDeleteConversationModalProps = {
  show: boolean
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterDeleteConversationModal: React.FC<
  MessageCenterDeleteConversationModalProps
> = ({ show, onCancel, onDelete }) => (
  <Modal
    open={show}
    onClose={onCancel}
    size="xs"
    title="Delete conversation"
    description="Are you sure you want to delete this conversation? This action can't be undone."
    primaryLabel="Delete"
    secondaryLabel="Cancel"
    primaryDestructive
    onPrimaryClick={onDelete}
    onSecondaryClick={onCancel}
  />
)

export default MessageCenterDeleteConversationModal
